module.exports = __webpack_public_path__ + "1cfd5dba4a9210bcf77f5dbe48ec2e66.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/en/apple_store.svg
// module id = 832
// module chunks = 0